import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://tripverse.co.uk";

interface SEOProps {
  title: string;
  description: string;
  noindex?: boolean;
  ogImage?: string;
  ogImageAlt?: string;
}

export const SEO = ({ title, description, noindex, ogImage, ogImageAlt }: SEOProps) => {
  const location = useLocation();
  const fullTitle = `TripVerse | ${title}`;
  const url = `${BASE_URL}${location.pathname}${location.search}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={url} />
      {ogImage && (
        <>
          <meta property="og:image" content={ogImage} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          {ogImageAlt && <meta property="og:image:alt" content={ogImageAlt} />}
        </>
      )}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};
